
module.exports = {"attributes":{"width":"27","height":"40"},"content":"<path d=\"M11.9 40C21.5 40 27 34.8 27 27c0-8.2-5.3-12-13-12-3.9 0-8.1 1-10.7 4l.6-11.5h20.7l.7-7.5h-22L2 20.8a12 12 0 0 1 5.7-1.3c5.5 0 8.7 2.8 8.7 8.5 0 5.8-3.3 9.1-9.6 9.1A16 16 0 0 1 0 35.5v1.3C2.6 38.6 6.8 40 11.9 40z\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
